var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunityGroupIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50002 4.66732V3.00065C5.50002 2.55862 5.67562 2.1347 5.98818 1.82214C6.30074 1.50958 6.72466 1.33398 7.16669 1.33398H13C13.442 1.33398 13.866 1.50958 14.1785 1.82214C14.4911 2.1347 14.6667 2.55862 14.6667 3.00065V13.0007C14.6667 13.4427 14.4911 13.8666 14.1785 14.1792C13.866 14.4917 13.442 14.6673 13 14.6673H7.16669C6.72466 14.6673 6.30074 14.4917 5.98818 14.1792C5.67562 13.8666 5.50002 13.4427 5.50002 13.0007V11.334M0.500021 8.00065H11.3334M11.3334 8.00065L8.83335 5.50065M11.3334 8.00065L8.83335 10.5007",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityGroupIcon);
export default __webpack_public_path__ + "static/media/communityGroupIcon.89b1724d985428756eb5d9d18328a3ae.svg";
export { ForwardRef as ReactComponent };